import * as types from './types'

interface ErrorAction {
    type: string
    error: Error
}

const errors = (state: Error[] = [], { type, error }: ErrorAction): Error[] => {
    switch (type) {
        case types.ADD_ERROR:
            return [ ...state, error ]
        case types.REMOVE_ERROR:
            return state.filter((err) => err !== error)
        default:
            return state
    }
}

export default errors
